
import Bowser from 'bowser'
import { SUBSCRIPTION_STATUS_ACTIVE } from '~/utils/constants'

export default {
  data () {
    const bowser = Bowser.getParser(window.navigator.userAgent)

    return {
      isIe: bowser.isBrowser('Internet Explorer')
    }
  },
  computed: {
    client () {
      return this.$store.state.auth.client
    },
    company () {
      return this.$store.getters['auth/company']
    },
    subscription () {
      return this.$store.getters['auth/mainSubscription']
    },
    features () {
      return this.$store.state.features
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler (fullPath) {
        this.$ph.capture('$pageview')
      }
    },
  },
  beforeMount () {
    this.addUserInformationToDataLayer()
  },
  methods: {
    closeIeWarning () {
      this.isIe = false
    },
    addUserInformationToDataLayer () {
      if (this.client) {
        this.$gtm.push({
          event: 'user_provided',
          user_id: this.client.id,
          user_email: this.client.attributes.email
        })

        this.$ph.identify(this.client.id, {
          email: this.client.attributes.email,
          app_v1_version: this.$config.APP_VERSION,
          language: this.client.attributes.language,
        })
      }

      if (this.company) {
        this.$ph.setPersonProperties({
          cw_id: this.company.id,
          cw_name: this.company.attributes.displayName,
          cw_country: this.company.attributes.country,
          cw_created_at: this.company.attributes.createdAt,
          cw_type: this.company.attributes.workspaceType,
          cw_subscription_status: this.company.attributes.subscription_status,
          cw_subscription_plan: this.company.attributes.subscription_plan,
        })

        this.$gtm.push({
          event: 'workspace_provided',
          workspace_id: this.company.id,
          workspace_type: this.company.attributes.workspaceType,
          workspace_has_active_subscription: this.subscription?.attributes.status === SUBSCRIPTION_STATUS_ACTIVE,
          workspace_country: this.company.attributes.country,
        })

        this.$ph.group('workspace', this.company.id, {
          name: this.company.attributes.displayName,
          country: this.company.attributes.country,
          created_at: this.company.attributes.createdAt,
          type: this.company.attributes.workspaceType,
          subscription_status: this.subscription?.attributes.status || null,
          subscription_plan: this.subscription?.attributes.planId || null,
        })
      }
    }
  }
}
